__turbopack_context__.v({
  "ActionBar": "JGq06q_ActionBar",
  "ActionBarClose": "JGq06q_ActionBarClose",
  "ActionBarTitle": "JGq06q_ActionBarTitle",
  "Announcement": "JGq06q_Announcement",
  "AnnouncementActive": "JGq06q_AnnouncementActive",
  "AnnouncementsContainer": "JGq06q_AnnouncementsContainer",
  "BannerBtn": "JGq06q_BannerBtn",
  "Column": "JGq06q_Column",
  "ContainerActive": "JGq06q_ContainerActive",
  "HasChildren": "JGq06q_HasChildren",
  "IconWithContent": "JGq06q_IconWithContent",
  "IndentContent": "JGq06q_IndentContent",
  "RightArrow": "JGq06q_RightArrow",
  "SvgContainer": "JGq06q_SvgContainer",
  "Title": "JGq06q_Title",
  "TitleContainer": "JGq06q_TitleContainer",
  "ToasterContent": "JGq06q_ToasterContent",
  "ToasterContentClose": "JGq06q_ToasterContentClose",
  "ToasterWrapper": "JGq06q_ToasterWrapper",
});
